












































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { bus } from "@/bus";
// components
import vSelect from "vue-select";
import FolderTree from "@/components/common/folders/FolderTree.vue";
import ChannelGroupInfoModal from "@/components/channels/modals/ChannelGroupInfoModal.vue";
import ChannelGroupDeleteModal from "@/components/channels/modals/ChannelGroupDeleteModal.vue";
import ChannelGroupCopyModal from "@/components/channels/modals/ChannelGroupCopyModal.vue";
import ChannelGroupPreviewModal from "@/components/channels/modals/ChannelGroupPreviewModal.vue";
// service methods
import { getFilteredChannelGroups } from "@/services/channels/channelGroupService";
import { getAllTemplates } from "@/services/templates/templateService";
import { getSolutions } from "@/services/solutions/solutionService";
// types
import { ChannelGroup, ChannelGroupsFilterDtoIn, ChannelGroupResolution } from "@/services/channels/types";
import { Folder, FolderEntites } from "@/services/folders/types";
import { Option } from "@/services/common/types";
import { channelGroupsFields } from "@/components/channels/fields/channelGroupsFields";

@Component({
    components: {
        vSelect,
        "folder-tree": FolderTree,
        "channel-group-info-modal": ChannelGroupInfoModal,
        "channel-group-delete-modal": ChannelGroupDeleteModal,
        "channel-group-copy-modal": ChannelGroupCopyModal,
        "channel-group-preview-modal": ChannelGroupPreviewModal
    }
})
export default class ChannelGroups extends Vue {
    // local state
    channelGroups = [] as Array<ChannelGroup>;
    fields = channelGroupsFields;
    isBusy = false;
    sortBy = "name";
    sortDesc = false;

    // folders
    folderEntity = FolderEntites.ChannelGroups;
    selectedFolderNode = {} as Folder;
    showFolderTree = true;

    // filter
    selectedTemplate = null as Option | any;
    selectedSolution = null as Option | any;
    filterResolution: ChannelGroupResolution | null = null;

    // filter options
    templates = [] as Array<Option>;
    solutions = [] as Array<Option>;
    searchText = "" as string;
    resolutions: ChannelGroupResolution[] = [];

    // lifecycle hooks
    public created(): void {
        this.fetchData();

        bus.$on("reload", () => {
            this.fetchData();
        });

        this.$nextTick(() => {
            this.sortBy = "name";
            this.sortDesc = false;
        });
    }

    beforeDestroy() {
        bus.$off("reload");
    }

    // methods & actions
    setChannelFolderId(data: { entityId: string, folderId: string }) {
        this.channelGroups.forEach((channelGroup) => {
            if (channelGroup.id === data.entityId) channelGroup.folderId = data.folderId;
        });
    }

    selectFolder(folder: Folder) {
        this.selectedFolderNode = folder;
    }

    toggleFolderTree() {
        if (!this.filterActive) {
            this.showFolderTree = !this.showFolderTree;
        }
    }

    deleteChannelGroup(channelGroupId: string, name: string) {
        (this.$refs.channelGroupDeleteModal as any).open(channelGroupId, name);
    }

    copyChannelGroup(channelGroupId: string) {
        (this.$refs.channelGroupCopyModal as any).open(channelGroupId);
    }

    channelGroupInfo(channelGroupId: string) {
        (this.$refs.channelGroupInfoModal as any).open(channelGroupId);
    }

    editChannelGroupRoute(channelGroupId: string) {
        return {
            name: "UpdateChannelGroup",
            params: {
                channelGroupId: channelGroupId
            }
        };
    }

    previewChannelGroup(channelGroupId: string, name: string) {
        (this.$refs.channelGroupPreviewModal as any).open(channelGroupId, name);
    }

    fetchData() {
        this.loadChannels();
        getAllTemplates().then(response => {
            this.templates = response.map(x => ({
                id: x.id,
                text: x.name
            }));
        });
        getSolutions().then(response => {
            this.solutions = response.map(x => ({
                id: x.id,
                text: x.name
            }));
        });
    }

    loadChannels() {
        this.isBusy = true;
        this.channelGroups = [] as Array<ChannelGroup>;
        getFilteredChannelGroups({
            templateId: this.selectedTemplate ? this.selectedTemplate.id : "",
            solutionsId: this.selectedSolution ? this.selectedSolution.id : ""
        } as ChannelGroupsFilterDtoIn).then(response => {
            this.channelGroups = response;
            this.isBusy = false;
            if (this.resolutions.length === 0) this.getResolutions();
        });
    }

    getResolutions() {
        const resolutions = this.channelGroups.map(x => ({ width: x.width, height: x.height, display: x.width + "x" + x.height }));
        this.resolutions = resolutions.filter((v, i, a) => a.findIndex(t => (t.width === v.width && t.height === v.height)) === i);
    }

    clearFilter() {
        this.selectedTemplate = null;
        this.selectedSolution = null;
        this.filterResolution = null;
        this.loadChannels();
    }

    // computed and watchers
    get model(): Array<ChannelGroup> {
        if (this.filterActive) {
            return this.channelGroups.filter(
                x => (this.searchText === "" ? true : x.name.toLowerCase().includes(this.searchText.toLowerCase())) &&
                    (!this.filterResolution ? true : x.width === this.filterResolution.width && x.height === this.filterResolution.height)
            );
        } else {
            return this.channelGroups.filter(
                x => this.selectedFolderNode.id ? x.folderId === this.selectedFolderNode.id : true
            );
        }
    }

    get filterActive(): boolean {
        return (
            (this.selectedTemplate && Object.keys(this.selectedTemplate.id).length > 0) ||
            (this.selectedSolution && Object.keys(this.selectedSolution.id).length > 0) ||
            this.filterResolution !== null ||
            this.searchText !== "");
    }

    get addChannel() {
        return {
            name: "CreateChannelGroup",
            params: {
                folderId: this.selectedFolderNode ? this.selectedFolderNode.id : ""
            }
        };
    }

    @Watch("filterActive")
    onFilterChanged(value: any, oldValue: any) {
        this.showFolderTree = !value;
    }

    // drag events
    drag(event: any) {
        event.dataTransfer.setDragImage(this.$refs["element_" + event.target.getAttribute("entityId")] as any, -10, 0);
        event.dataTransfer.setData(
            "type",
            event.target.getAttribute("type")
        );
        event.dataTransfer.setData(
            "folderEntity",
            event.target.getAttribute("folderEntity")
        );
        event.dataTransfer.setData(
            "entityId",
            event.target.getAttribute("entityId")
        );
    }
}
